import React, { useEffect, useState } from 'react'
import { Card, Button, FormControl, Form } from 'react-bootstrap'
import './package.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const Package = (props: {
    header: string,
    services: any[],
    price?: number,
    color?: string,
    textFieldUpdated?: any,
    buttonText?: string,
    buttonPressed?: any,
    textFieldPlaceholder?: string,
    selected?: boolean,
    discount?: number
}) => {

    const [styleClassName, setStyleClassName] = useState("")

    useEffect(() => {
        if (props.selected) {
            setStyleClassName("selected-" + (props.color ?? "primary"))
            return
        }

        setStyleClassName("white-bg")

    }, [props.selected, props.color])

    const roundNearest5 = (num: number) => {
        return Math.round(num / 5) * 5;
    }

    useEffect(() => {
        console.log(styleClassName)
    }, [styleClassName])

    return (
        <Card bg={props.color ?? "primary"} className={props.selected ? "selected" : ""}>
            <Card.Header style={{ textAlign: "center", color: "white" }} >
                {props.color === "primary" && <i className="fa-solid fa-spray-can-sparkles me-2"></i>}
                {props.color === "success" && <i className="fa-solid fa-droplet me-2"></i>}
                {props.color === "warning" && <i className="fa-solid fa-toolbox me-2"></i>}
                {props.color === "info" && <i className="fa-solid fa-brush me-2"></i>}
                <strong>{props.header}</strong>
                {props.discount && <span className="discount-badge">{(props.discount * 100)}% OFF</span>}
            </Card.Header>
            <Card.Body style={{ color: props.selected ? "white" : "black" }} className={styleClassName} >
                <ul className="feature-list">
                    {
                        props.services.map(s => {
                            return (<li>
                                <i className="fa-solid fa-check-circle"></i> {s}
                            </li>)
                        })
                    }
                </ul>
                {
                    props.textFieldPlaceholder &&
                    <FormControl min={0} type="number"
                        style={
                            {
                                backgroundColor: props.selected ? "lightgray" : "white"
                            }
                        }
                        disabled={props.selected == true} onChange={(e) => props.textFieldUpdated(e.target.value)} placeholder={props.textFieldPlaceholder} />
                }
                <Card.Text>
                    {
                        props.price &&
                        <div style={{ textAlign: "center" }} className="mt-4">
                            {
                                props.discount && <h4 style={{ textDecoration: "line-through", color: props.selected ? "rgba(255,255,255,0.7)" : "#777" }}>${roundNearest5(props.price)}</h4>
                            }
                            <div className="price-tag">
                                <i className={`fa-solid fa-tag me-2 ${props.selected ? 'tag-icon-selected' : ''}`}></i>
                                ${roundNearest5(props.price * (1 - (props.discount ?? 0)))}
                            </div>
                        </div>
                    }
                </Card.Text>

            </Card.Body>
            <Card.Footer style={{ backgroundColor: "white", textAlign: "center", borderTop: "1px solid rgba(0,0,0,0.05)" }}>
                <Button onClick={props.buttonPressed} variant={props.color ?? "primary"} className="pill-btn">{
                    !props.selected ? (<><i className="fa-solid fa-plus me-1"></i>{props.buttonText ?? "Select Service"}</>) :
                        <FontAwesomeIcon icon={faCheck} />
                }</Button>
            </Card.Footer>
        </Card>
    )

}

export default Package